import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-12 pt-10 lg:px-8 lg:pb-16 lg:pt-14" data-id="element-99" data-mp="16njcg4ablb52">
      <div className="mx-auto max-w-4xl text-center" data-id="element-100" data-mp="16lgkvftir9y8">
        <h1 className="font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-101" data-mp="12mzeiyhxa3hv">
          Your Next Lash &amp; Brow Class, <Accent data-id="element-102" data-mp="1ucvu7sjpqriz">Ready in Minutes.</Accent>
        </h1>

        <p className="mt-5 font-body text-[11px] font-bold uppercase tracking-[0.18em] text-brand-gold-dark sm:text-[12px]" data-id="element-103" data-mp="1ubb0241b9aln">
          For Lash &amp; Brow Instructors &amp; Beauty Educators
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Lash & Brow Instructor Ready™ — the six volumes with interior pages shown on a tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-8 block w-full max-w-[640px] object-contain lg:max-w-[920px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(120, 90, 60, 0.2))'
    }} data-id="element-104" data-mp="ewdkwc8o0lre" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-105" data-mp="2zgg147s2ysyk">
        Stop spending hours creating lessons, exercises, and assessments from scratch. Get a complete collection of
        structured lash and brow teaching resources — organized and ready to use.
      </p>

      <CtaBlock label="Get my teaching system" className="mt-7" data-id="element-106" data-mp="2ui4q3tq1ucer" />

      <p className="mt-5 text-center font-body text-[12px] font-bold uppercase tracking-[0.14em] text-brand-gold-dark" data-id="element-107" data-mp="2gpycaeadchih">
        6 Professional Volumes + 5 Bonuses | Instant Digital Access
      </p>
    </section>;
}